import { InputAdornment, TextField } from "@mui/material";
import { ErrorMessage } from "formik";
import "./Field.scss";
import { useState } from "react";
import { VscEye, VscEyeClosed } from "react-icons/vsc";

const Field = (props: any) => {
  const [displayPassword, setDisplayPassword] = useState(false);

  return (
    <TextField
      {...props}
      fullWidth
      variant="outlined"
      margin="dense"
      type={
        props?.type === "password" && displayPassword ? "text" : props?.type
      }
      placeholder={props.placeholder || props.placeHolder}
      className="input-field"
      inputProps={{ maxLength: props.max, min: props.min }}
      InputProps={{
        endAdornment:
          props?.type === "password" ? (
            <InputAdornment
              position="end"
              className="textfield-icon"
              onClick={() => setDisplayPassword(!displayPassword)}
            >
              {displayPassword ? <VscEyeClosed /> : <VscEye />}
            </InputAdornment>
          ) : (
            props?.iconType === "Percentage" && (
              <InputAdornment position="end">%</InputAdornment>
            )
          ),
      }}
      style={
        props.borderRadius
          ? { borderRadius: "0 0 30px" }
          : { borderRadius: "40px !important" }
      }
      helperText={<ErrorMessage name={props.name} />}
      onWheel={(e: any) => e.target.blur()}
      onKeyDown={(e) => {
        if (props?.enterkey !== "true") e.key === "Enter" && e.preventDefault();
      }}
    />
  );
};

export default Field;
